import { gql, TypedDocumentNode } from "@apollo/client";

import {
  MutationTemplateDeploymentCreateArgs,
  MutationTemplateDeploymentUpdateArgs,
  TemplateDeployment,
} from "types/generated";

type FetchTemplateCreateStack = {
  templateDeploymentCreate: TemplateDeployment;
};

export const TEMPLATE_CREATE_STACK: TypedDocumentNode<
  FetchTemplateCreateStack,
  MutationTemplateDeploymentCreateArgs
> = gql`
  mutation TemplateDeploymentCreate($id: ID!, $input: TemplateDeploymentCreateInput!) {
    templateDeploymentCreate(id: $id, input: $input) {
      id
      name
    }
  }
`;

type FetchTemplateUpdateDeployment = {
  templateDeploymentUpdate: TemplateDeployment;
};

export const TEMPLATE_UPDATE_VERSION_DEPLOYMENT: TypedDocumentNode<
  FetchTemplateUpdateDeployment,
  MutationTemplateDeploymentUpdateArgs
> = gql`
  mutation TemplateDeploymentVersionUpdate(
    $templateID: ID!
    $id: ID!
    $input: TemplateDeploymentUpdateInput!
  ) {
    templateDeploymentUpdate(templateID: $templateID, id: $id, input: $input) {
      id
      name
    }
  }
`;
